import { useEffect, useState } from 'react'
import { useNavigate } from '@tanstack/react-router'
import { api } from '@/runtime'
import { PageTitle } from '@/components/ui'

/**
 * Where Spotify sends the browser back. An app page rather than a server
 * route, because the service worker answers every navigation with the app
 * shell; the code and state are posted to the API from here, with this
 * device's token, and the result lands on Settings → Spotify.
 */
export const SpotifyCallbackView = () => {
  const navigate = useNavigate()
  const [text, setText] = useState('Finishing the Spotify approval…')
  useEffect(() => {
    const q = new URLSearchParams(window.location.search)
    const done = (outcome: 'connected' | 'refused' | 'failed') =>
      void navigate({
        to: '/settings/$section',
        params: { section: 'spotify' },
        search: { spotify: outcome } as never,
        replace: true,
      })
    if (q.get('error')) {
      done('refused')
      return
    }
    api
      .spotifyCallback(q.get('state') ?? '', q.get('code') ?? '')
      .then(() => done('connected'))
      .catch((e: unknown) => {
        setText(e instanceof Error ? e.message : 'That approval did not go through.')
        setTimeout(() => done('failed'), 1500)
      })
  }, [navigate])
  return (
    <div>
      <PageTitle eyebrow="Spotify">One moment</PageTitle>
      <p className="text-sm text-muted" role="status">
        {text}
      </p>
    </div>
  )
}
